import React from "react";
import * as StateValueCalculator from "./StateValueCalculations.js";

export default function Link(props) {
  const linkData = props.linkData;
  const priipKey = props.priipKey;
  const allSelectedDropdowns = props.allSelectedDropdowns;

  return (
    StateValueCalculator.evaluateLinkvisibilityConditions(
      allSelectedDropdowns,
      linkData.conditions
    ) && (
      <div className="result">
        <b> {linkData.label} </b>
        <a
          target="_blank"
          href={`${linkData.directory}${priipKey}.pdf`}
          rel="noopener noreferrer"
        >
          {" "}
          {priipKey}
          {".pdf"}
        </a>
      </div>
    )
  );
}



// WEBPACK FOOTER //
// ./src/js/Link.js